import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=4b68ad00&scoped=true&"
var script = {}
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=4b68ad00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68ad00",
  null
  
)

export default component.exports